import { useState } from "react";
import InputFactory from "../../../../../components/InputFactory";
import FormField from "./FormField";

function LocationFields({
  formData,
  onChange,
  regionsOptions,
  provincesOptions,
  citiesOptions,
  barangayOptions,
  provinceRef,
  cityRef,
  barangayRef,
  ...props
}) {
  return (
    <div className="d-flex flex-column gap-3 rounded-3">
      <div
        className={`col-12 rounded-1 d-flex border-bottom align-items-center pb-1 gap-2`}
      >
        <div className="p-1 rounded-1 bg-light border border-1 px-2">
          <i className={`bi bi-geo-alt text-primary fw-bold`}></i>
        </div>
        <div className="d-flex flex-column gap-0">
          <p className="small fw-bold mb-0 text-primary">Location</p>
          <p className="small mb-0 text-muted">
            Supplier address (region, province, city, barangay, street)
          </p>
        </div>

        <hr />
      </div>
      <FormField label="Region" required>
        <InputFactory
          type="Enum"
          field="region"
          required
          placeholder="Select Region"
          defaultValue={formData.region}
          options={regionsOptions}
          onChange={onChange}
          {...props}
        />
      </FormField>

      <FormField label="Province" required={!!provincesOptions.length}>
        <InputFactory
          type="Enum"
          field="province"
          placeholder="Select Province"
          required={!!provincesOptions.length}
          disabled={!provincesOptions.length}
          defaultValue={formData.province}
          options={provincesOptions}
          className={`border border-1 border-dark-subtle ${
            !provincesOptions.length ? "bg-light" : "bg-white"
          }`}
          onChange={onChange}
          resetRef={provinceRef}
          {...props}
        />
      </FormField>

      <FormField label="City/Municipality" required>
        <InputFactory
          type="Enum"
          field="city"
          required
          placeholder="Select City/Municipality"
          defaultValue={formData.city}
          disabled={!formData.region}
          options={citiesOptions}
          className={`border border-1 border-dark-subtle ${
            !formData.region ? "bg-light" : "bg-white"
          }`}
          onChange={onChange}
          resetRef={cityRef}
          {...props}
        />
      </FormField>

      <FormField label="Barangay" required>
        <InputFactory
          type="Enum"
          field="barangay"
          required
          placeholder="Select Barangay"
          defaultValue={formData.barangay}
          disabled={!formData.city}
          options={barangayOptions}
          className={`border border-1 border-dark-subtle ${
            !formData.city ? "bg-light" : "bg-white"
          }`}
          onChange={onChange}
          resetRef={barangayRef}
          {...props}
        />
      </FormField>

      <FormField label="Street" required>
        <InputFactory
          type="String"
          field="street"
          required
          placeholder="Enter Street"
          defaultValue={formData.street}
          className="border border-1 bg-white  border-dark-subtle"
          onChange={onChange}
          {...props}
        />
      </FormField>

      <FormField label="Full Address" required>
        <InputFactory
          type="Text"
          field="fullAddress"
          required
          placeholder="Enter full address"
          defaultValue={formData.fullAddress}
          onChange={onChange}
          {...props}
        />
      </FormField>
    </div>
  );
}

export default LocationFields;
